"use client";

import React from "react";
import { Zap, MessageSquare, TrendingUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const engineFeatures = [{
  title: "Strategic Leadership",
  description: "Fractional CTO expertise to navigate the complex intersection of healthcare compliance, data security, and digital innovation.",
  icon: Zap
}, {
  title: "Software Solutions",
  description: "The Eir SaaS platform empowers providers with data-driven insights for precision genetic clinical decision-making and workflows.",
  icon: MessageSquare
}, {
  title: "Lab & Diagnostics",
  description: "In-house genetic testing laboratory providing rapid, accurate molecular analysis for personalized patient care and diagnostics.",
  icon: TrendingUp
}];
export default function TheViralityEngine() {
  return <section data-section-id="224052" id="the-eirion-ecosystem" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <style>{`
        @keyframes glitch-jitter {
          0% { transform: translate(0, 0); }
          20% { transform: translate(-2px, 1px); }
          40% { transform: translate(2px, -1px); }
          60% { transform: translate(-1px, 2px); }
          80% { transform: translate(1px, -2px); }
          100% { transform: translate(0, 0); }
        }
        .group:hover .animate-glitch {
          animation: glitch-jitter 0.2s linear infinite;
        }
      `}</style>

      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-6xl font-default font-bold tracking-tighter mb-4">
            The Eirion Ecosystem
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-xl leading-relaxed">
            Integrating strategic leadership, precision software, and advanced diagnostics to redefine the future of clinical outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {engineFeatures.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              {}
              <Card className={`h-full bg-card/40 backdrop-blur-xl border-white/10 transition-all duration-500 ease-out group-hover:-translate-y-2 relative overflow-hidden rounded-xl shadow-none ${i === 0 ? "group-hover:border-slate-400/40" : i === 1 ? "group-hover:border-primary/40" : "group-hover:border-secondary/40"}`}>
                
                {}
                <div className={`absolute bottom-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${i === 0 ? "bg-slate-400 shadow-[0_0_20px_rgba(148,163,184,0.6)]" : i === 1 ? "bg-primary shadow-[0_0_20px_var(--color-primary)]" : "bg-secondary shadow-[0_0_20px_var(--color-secondary)]"}`} />
                
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none shadow-[inset_0_0_40px_rgba(255,255,255,0.02)]" />

                <CardHeader className="pt-8 pb-4 relative z-10">
                  <div className={`mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full border shadow-sm transition-all duration-500 ${i === 0 ? "bg-slate-400/10 border-slate-400/20 shadow-slate-400/10" : i === 1 ? "bg-primary/10 border-primary/20 shadow-primary/10" : "bg-secondary/10 border-secondary/20 shadow-secondary/10"}`}>
                    <feature.icon className={`w-8 h-8 animate-glitch transition-transform ${i === 0 ? "text-slate-300 drop-shadow-[0_0_8px_rgba(148,163,184,0.5)]" : i === 1 ? "text-primary drop-shadow-[0_0_8px_var(--color-primary)]" : "text-secondary drop-shadow-[0_0_8px_var(--color-secondary)]"}`} />
                  </div>
                  <CardTitle className="text-2xl font-bold font-default tracking-tight text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="pb-8 relative z-10">
                  <CardDescription className="text-muted-foreground font-default text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}